/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './health-camp-transaction.reducer';

export const HealthCampTransactionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const healthCampTransactionEntity = useAppSelector(state => state.healthCampTransaction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="healthCampTransactionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.healthCampTransaction.detail.title">HealthCampTransaction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.id">Id</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.id}</dd>
          <dt>
            <span id="transactionDate">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.transactionDate">Transaction Date</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.transactionDate}</dd>
          <dt>
            <span id="organizerType">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.organizerType">Organizer Type</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.organizerType}</dd>
          <dt>
            <span id="organizerId">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.organizerId">Organizer Id</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.organizerId}</dd>
          <dt>
            <span id="transactionType">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.transactionType">Transaction Type</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.transactionType}</dd>
          <dt>
            <span id="transactionId">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.transactionId">Transaction Id</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.transactionId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.active">Active</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.healthCampTransaction.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{healthCampTransactionEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.healthCampTransaction.camp">Camp</Translate>
          </dt>
          <dd>{healthCampTransactionEntity.camp ? healthCampTransactionEntity.camp.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/health-camp-transaction" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/health-camp-transaction/${healthCampTransactionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HealthCampTransactionDetail;
